import { object, SchemaOf, string } from 'yup';

import { ResumeBillingVariables } from '@/graphql/contracts/_generated_/resumeBilling.mutation';


type FieldKeys = Exclude<keyof ResumeBillingVariables, 'contractId'>;

type Fields = {
  [key in FieldKeys]: ResumeBillingVariables[key] | '';
};

export const initialValues: Fields = {
  comment: ''
};

export const validationSchema: SchemaOf<Fields> = object().shape({
  comment: string()
    .max(100, 'Must be maximum 100 characters'),
});
